export default {
      id: "arrowRight-usage",
      viewBox: "0 0 112.356 110.606",
      url: "../../assets/" + "sprite.svg#arrowRight-usage",
      toString: function () {
        return this.url;
      }
    }